"use client"

import { HomePageLayout } from "@/components/website/homepage-layout"

export default function AboutUsPage() {
  return (
    <HomePageLayout>
      <div className="container mx-auto px-4 py-6">
        <h1 className="text-2xl font-bold mb-4">About Us</h1>
        <p className="mb-3">
          Oxygen Tamil News is a digital-first news platform focused on fast, accurate and people-centric coverage of Tamil Nadu, India and the world.
          Our editorial team brings together experienced journalists and young storytellers to deliver breaking news, in-depth analysis, and engaging features
          across politics, cinema, sports, business, lifestyle and more.
        </p>
        <p className="mb-3">
          We believe news should be clear, credible and accessible in your own language. Every story we publish goes through a careful editorial process
          to verify facts, provide context, and avoid sensationalism. Our goal is to help readers stay informed, make better decisions, and feel connected
          to what is happening around them.
        </p>
        <p>
          As we grow, we are committed to investing in local reporting, innovative storytelling formats, and technology that makes news faster and easier
          to access on any device.
        </p>
      </div>
    </HomePageLayout>
  )
}


